function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspekceVyskovychStaveb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.89 156.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.03,137.78L72.84,6.02c-.05-1.68-1.43-3.02-3.11-3.02H16.53c-1.68,0-3.06,1.33-3.11,3.02l-4.19,131.77c-.05,1.68-1.43,3.02-3.11,3.02h0c-1.72,0-3.11,1.39-3.11,3.11v6.51c0,1.72,1.39,3.11,3.11,3.11h74.03c1.72,0,3.11-1.39,3.11-3.11v-6.51c0-1.72-1.39-3.11-3.11-3.11h0c-1.68,0-3.06-1.33-3.11-3.02Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.3,69.27l-2.58-.72c-.35-.1-.72-.13-1.08-.11l-10.07.79c-.14.01-.28.01-.41,0l-14.75-.81c-.36-.02-.71-.1-1.04-.24l-10.92-4.6c-.45-.19-.94-.27-1.43-.24l-9.75.71c-.76.06-1.52-.17-2.13-.64l-1.94-1.49c-2.01-1.55-4.93-.17-5.01,2.37l-2.34,73.48c-.05,1.68-1.43,3.02-3.11,3.02h0c-1.72,0-3.11,1.39-3.11,3.11v6.51c0,1.72,1.39,3.11,3.11,3.11h74.03c1.72,0,3.11-1.39,3.11-3.11v-6.51c0-1.72-1.39-3.11-3.11-3.11h0c-1.68,0-3.06-1.33-3.11-3.02l-2.09-65.62c-.04-1.36-.96-2.53-2.27-2.9Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.18,64.86l9.75-.71c.49-.04.98.05,1.43.24l10.92,4.6c.33.14.68.22,1.04.24l14.75.81c.14,0,.28,0,.41,0l10.07-.79c.36-.03.73,0,1.08.11l.69.19c2.03.57,4.02-1,3.95-3.1l-1.89-59.62c-.05-1.68-1.43-3.02-3.11-3.02h-53.2c-1.68,0-3.06,1.33-3.11,3.02l-1.61,50.61c-.03,1,.42,1.96,1.21,2.57l5.5,4.23c.61.47,1.36.69,2.13.64Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.25 89.4 116.16 73.49 100.25 57.58 100.25 89.4",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspekceVyskovychStaveb);
export default __webpack_public_path__ + "static/media/inspekce-vyskovych-staveb.2dbb34657754b9c2ca8490f13a5ad4cb.svg";
export { ForwardRef as ReactComponent };